import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

export const DragSelectionHide = Extension.create({
  name: 'dragSelectionHide',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('dragSelectionHide'),
        view(editorView) {
          const handleDragStart = () => {
            editorView.dom.classList.add('selection:bg-transparent');

            const cleanup = () => {
              editorView.dom.classList.remove('selection:bg-transparent');
              document.removeEventListener('dragend', cleanup);
              document.removeEventListener('mouseup', cleanup);
            };

            document.addEventListener('dragend', cleanup, { once: true });
            document.addEventListener('mouseup', cleanup, { once: true });
          };

          document.addEventListener('dragstart', handleDragStart);

          return {
            destroy() {
              document.removeEventListener('dragstart', handleDragStart);
            },
          };
        },
      }),
    ];
  },
});
